export default {
  name: "BackgroundVideo"
};